import React from 'react';
import './Sections.scss';

function Section7() {
  return (
    <section className="sections sections-section7">
      <h2 className="sections-title">A good investment starts with a good deal</h2>
      <p className="sections-copy">
        With mortgage rates moving northward of 7%, housing demand has certainly cooled. But demand
        continues to outpace housing supply overall. In short: there are still not enough homes, and
        America as a whole continues to build fewer new homes than is needed. And with strong
        continued demand for homes and no apparent improvements in sight to end this decadeslong
        housing shortage, the real estate market seems poised for further appreciation.
      </p>
      <p className="sections-copy">
        “Nothing is guaranteed, but historically home prices have generally marched higher,” notes
        Yun. “Buyers who are sitting on the sidelines now waiting for a better entry point could
        miss out on a lot of potential gains.”
      </p>
      <p className="sections-copy">
        History may be a good guide: Even during 1980 and 1982, when both inflation and mortgage
        rates were rising significantly, home prices still grew 5% on average.
      </p>
      <p className="sections-copy">
        Still, not every home makes an equally good investment. The key for buyers is to find a home
        in an up-and-coming area and make sure they don’t overpay.
      </p>
      <p className="sections-copy">
        That’s where REALTORS®, members of the National Association of REALTORS®, can help. They
        have local expertise combined with the latest information from{' '}
        <a
          className="hyperLink"
          href="https://www.nar.realtor/research-and-statistics"
          target="_blank"
          rel="noreferrer"
        >
          NAR research
        </a>{' '}
        on market trends and statistics. This detailed knowledge enables REALTORS® to guide buyers
        in negotiating the best deals that make homeownership possible and sets you on the path to
        wealth building.
      </p>
    </section>
  );
}

export default Section7;
